import { render, staticRenderFns } from "./DemoGp.vue?vue&type=template&id=d91f6456"
import script from "./DemoGp.vue?vue&type=script&lang=js"
export * from "./DemoGp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports